export const CONFIG = {
  APP_NAME: 'Hagius',
  APP_AUTHOR: 'Felipe Augusto',
};
